module.exports = {
	transpileDependencies: true,
	publicPath: process.env.VUE_APP_PUBLIC_PATH ?? '/',
	devServer: {
        proxy: process.env.VUE_APP_PROXY,
		webSocketServer: false,
		historyApiFallback: true,
	},
	css: {
		loaderOptions: {
		  sass: {
			additionalData: ``
		  }
		}
	  }
};

